import React from "react";

function Navbar() {
  return (
    <div className="d-flex justify-content-center mb-5">
      {/* <div
        style={{ backgroundColor: "#212529", borderRadius: "50px" }}
        className="px-5 py-2"
      >
        <div className="d-flex justify-content-between gap-5">
          <div>Logo</div>
          <div>Menu Items</div>
        </div>
      </div> */}
    </div>
  );
}

export default Navbar;
